import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { plazaServices } from './tollPlaza/plazaReportService';
import * as XLSX from 'xlsx';
import { commonConfigCaller } from './FeatureDetails';
import moment from 'moment';
import { Dialog } from 'primereact/dialog';
import { superAdmin } from '../lib/constants';

const Vendor = () => {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState(null);
    const [vendor, setVendor] = useState("All");
    const serviceId = localStorage.getItem('serviceId')
    const [visible, setVisible] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [formData, setFormData] = useState({
        address: '',
        mobile: '',
        email: '',
        vendorName: '',
        websiteURL: '',
    });
    const [admin, setAdmin] = useState(false)
    const [infoMsg, setInfoMsg] = useState('');
    const [disableBtn, setDisableBtn] = useState(false);
    const mapToProps = {
        'vendorName': "Name",
        'mobile': "Contact Number",
        'email': "Email Address",
        'address': "Address",
        'websiteURL': "Website URL"
    }
    const handleFileUpload = async () => {
        let formDataToSend = new FormData();
        formDataToSend.append("serviceId", serviceId);
        Object.entries(formData).forEach(([key, value]) => {
            formDataToSend.append(key, value);
        });
        const requiredFields = ["serviceId", "email", "address", "mobile", "vendorName", "websiteURL"];
        for (let field of requiredFields) {
            const value = formDataToSend.get(field)?.toString().trim();

            if (!value || value.length === 0) {
                setInfoMsg(`Please fill the required field`);
                return;
            }
            if (field === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                setInfoMsg("Please enter a valid email address.");
                return;
            }
            if (field === "mobile" && !/^\d{10}$/.test(value)) {
                setInfoMsg("Please enter a valid 10-digit mobile number.");
                return;
            }
            let website_validator = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
            if (field === 'websiteURL' && !website_validator.test(value)) {
                setInfoMsg("Please enter a valid website url.");
                return;
            }
        }
        if (formData["email"]) formDataToSend.append("vendorID", formData["email"][0].toUpperCase() + formData["email"][1].toUpperCase() + Date.now());
        try {
            setDisableBtn(true);
            // Ask backend team to add websiteURL as key in the API call
            const res = await commonConfigCaller(
                "imaginehomes/upsertVendorDetails/",
                "post",
                formDataToSend,
                process.env.REACT_APP_API_PARSER_URL
            );
            if (res?.status === 200) {
                setInfoMsg("Vendor added Sucessfully");
            } else {
                setInfoMsg("Failed to add a vendor.");
            }

        } catch (error) {
            setInfoMsg("Failed to add a vendor.")
            console.error("Error during add vendor:", error.message);
            alert(`Error: ${error.message}`);
        } finally {
            setRefresh(!refresh)
            setDisableBtn(false);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
    }
    const exportToExcel = () => {
        const formattedProducts = filteredProducts.map(({ _id, ...rest }) => ({
            Time: moment().format('MM-DD-YY HH:mm:ss'),
            ...Object.fromEntries(
                Object.entries(rest).map(([key, value]) => [
                    key.charAt(0).toUpperCase() + key.slice(1),
                    value
                ])
            )
        }));
        const worksheet = XLSX.utils.json_to_sheet(formattedProducts);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Vendor List");
        XLSX.writeFile(workbook, 'Vendor_List.xlsx');
    };

    const fetchData = async () => {
        try {
            const vendorResponse = await plazaServices.general(serviceId, {}, "nq-products-vendors");
            setProducts(vendorResponse);
            setFilteredProducts(vendorResponse);
            const formattedVendors = vendorResponse.map(v => ({ label: v.name, value: v.name }));
            setVendorList([{ label: "All", value: "All" }, ...formattedVendors]);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let array = JSON.parse(localStorage.getItem("permissions"));
        if (array.includes(superAdmin)) setAdmin(true)
        fetchData();
    }, [refresh]);

    useEffect(() => {
        const filteredData = products.filter(product => {
            const matchesItem = !item || product.name.toLowerCase().includes(item.toLowerCase()) || product.vendorID.toLowerCase().includes(item.toLowerCase()) || product.email.toLowerCase().includes(item.toLowerCase());
            const matchesVendor = vendor === "All" || product.name === vendor;
            return matchesItem && matchesVendor;
        });
        setFilteredProducts(filteredData);
    }, [item, vendor]);
    function truncate(text, maxLength) {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    }
    const fieldLabelMap = {
        vendorID: "Vendor ID",
        name: "Name",
        email: "Email",
        address: "Address",
        mobile: "Mobile",
        websiteURL: "Website URL"
    };



    const urlBodyTemplate = (rowData, key) => {
        if (key.toLowerCase() === "websiteurl") {
            const url = rowData['websiteURL'];
            return (
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                >
                    {url ? truncate(url.toString(), 20) : ""}
                </a>
            );
        } else {
            return <p style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>{rowData[key]}</p>
        }
    };

    return (
        <div className="col-12 grid card shadow-3 p-3 border-round align-items-center justify-content-between" style={{ fontFamily: "Inter", backgroundColor: "#FBF9F3" }}>
            <h2 className=" m-0 charcoal-color lg:col-5 col-12" style={{ whiteSpace: "nowrap", fontFamily: "Inter" }}>
                Vendor Details
            </h2>
            <Dialog header="Add Vendor Details" visible={visible} className='lg:col-4 col-12' onHide={() => {
                setVisible(!visible);
                setFormData({
                    address: '',
                    mobile: '',
                    email: '',
                    vendorName: ''
                });
                setInfoMsg("");
            }}>
                <div className="col-12 grid justify-content-center">
                    <p className='col-12 flex justify-content-center' style={{ color: infoMsg === "Vendor added Sucessfully" ? "#9AAB89" : "red" }}
                    > {infoMsg}</p>
                    {['vendorName', 'mobile', 'email', 'address', 'websiteURL'].map(field => (
                        <div key={field} className="col-12 mb-3">
                            <label htmlFor={field} className="font-bold text-lg mb-1 font-larken  charcoal-color">
                                {mapToProps[field]}
                            </label>
                            <InputText
                                id={field}
                                name={field}
                                style={{
                                    border: `2px solid ${formData[field] ? 'green' : 'red'}`,  // Dynamic border color
                                    borderRadius: "22px",
                                    padding: "0.75rem 1rem"
                                }}
                                value={formData[field]}
                                onChange={handleChange}
                                placeholder={`Enter your ${field.charAt(0).toUpperCase() + field.slice(1)}`}
                                className={`w-full p-2  shadow-2 font-larken  charcoal-color ${formData[field] ? 'surface-100' : 'surface-50'}`}
                            />
                            {!formData[field] && (
                                <small className="text-red-500">* {field} is required</small>
                            )}
                        </div>
                    ))}
                    <Button className='font-larken m-0 mb-4' label="Submit" onClick={handleFileUpload} disabled={disableBtn} />
                </div>
            </Dialog>

            <div className="flex flex-wrap lg:gap-3 gap-0 align-items-center mb-3 lg:col-7 col-12">
                <div className="lg:col-5 col-12">
                    <span className="p-input-icon-left w-full" style={{ position: "relative" }}>
                        <i className="pi pi-search" style={{ color: "#6B7280" }} />
                        <InputText
                            value={item}
                            onChange={(e) => setItem(e.target.value)}
                            placeholder="Search"
                            className="font-Gerstner-ProgramRegular w-full"
                            style={{
                                borderRadius: "20px",
                                boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                border: "1px solid #ddd",
                                background: "transparent",
                                padding: "10px 40px 10px 40px",
                                fontSize: "14px",
                                fontFamily: "Inter",
                                height: "3rem",
                            }}
                        />
                        {item && (
                            <i
                                className="pi pi-times cursor-pointer"
                                style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#6B7280",
                                    fontSize: "14px",
                                    zIndex: 10
                                }}
                                onClick={() => setItem('')}
                            />
                        )}
                    </span>
                </div>

                <div className="lg:col-5 col-12">
                    <Dropdown
                        value={vendor}
                        options={vendorList}
                        onChange={(e) => setVendor(e.value)}
                        placeholder="Select Vendor"
                        className="font-Gerstner-ProgramRegular w-full"
                        style={{
                            borderRadius: "20px",
                            boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                            border: "1px solid #ddd",
                            background: "transparent",
                            height: "3rem",
                            fontSize: "14px",
                            fontFamily: "Inter"
                        }}
                    />
                </div>

                <div className="lg:col-1 col-6">
                    <Button
                        style={{
                            background: "white",
                            height: "40px",
                            boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                            border: "1px solid #ddd",
                            color: "#3d3d3d",
                            borderRadius: "20px",
                            padding: "10px 20px",
                            whiteSpace: "nowrap"

                        }}
                        icon="pi pi-download"
                        onClick={exportToExcel}
                        className="p-button-primary w-full"
                        tooltip="Download"
                        tooltipOptions={{ position: "bottom" }}
                    />
                </div>

                <div className="lg:col-1 col-6">
                    {admin && (
                        <Button
                            style={{
                                background: "white",
                                height: "40px",
                                boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                border: "1px solid #ddd",
                                color: "#3d3d3d",
                                borderRadius: "20px",
                                padding: "10px 20px",
                                whiteSpace: "nowrap"

                            }}
                            icon="pi pi-plus"
                            onClick={() => setVisible(true)}
                            className="p-button-primary w-full"
                            tooltip="Add Product"
                            tooltipOptions={{ position: "bottom" }}
                        />
                    )}
                </div>
            </div>
            <DataTable
                value={filteredProducts}
                loading={loading}
                responsiveLayout="scroll"
                rows={10}
                className="w-full card-table"
                rowClassName={() => 'card-row'}
            >
                {["vendorID", "name", "email", "address", "mobile", "websiteURL"].map((key) => (
                    <Column
                        key={key}
                        field={key}
                        header={fieldLabelMap[key]}
                        body={(rowData) => urlBodyTemplate(rowData, key)}
                        bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader"
                    />
                ))}
            </DataTable>
        </div>
    );
};

export default Vendor;

